import { useQuery } from '@tanstack/react-query';

import { fetchTestById } from 'apis/hcp/tests.api';
import { Test } from 'types/hcp/test.type';
import { transformDevice } from 'utils/hcp/test/test.helper';

const transformResponse = (response: { data: { test: Test } }) => {
  return {
    ...response.data.test,
    device: transformDevice(response.data.test.sensor_type),
  };
};

const getUtcOffset = (test?: Test) => {
  try {
    return test?.recordings[0]?.start_utc_offset;
  } catch {
    return null;
  }
};

const useGetTestDetails = (id: string) => {
  const {
    data: test,
    isPending,
    error,
  } = useQuery({
    queryKey: ['test', id],
    queryFn: ({ signal }) => fetchTestById(id, signal),
    select: transformResponse,
    enabled: !!id,
    retry: 5,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });
  const utcOffset = getUtcOffset(test);
  const isArchived = !!test?.archived_at;
  return { test, utcOffset, isPending, error, isArchived };
};

export default useGetTestDetails;
